// extracted by mini-css-extract-plugin
export default {"container":"IHvhRCvQSuQWxsABrkjb","titulo":"XBRwuLR4PYISqgBZa74l","photo":"GvJwrfzp6nA8gO0LHIL5"};